//import tags
import { Container, Row, Col, Image } from 'react-bootstrap';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Link } from "react-router-dom";
import { Navigation, A11y } from 'swiper/modules';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faKey, faArrowRight } from '@fortawesome/free-solid-svg-icons';

import 'swiper/css';
import 'swiper/css/navigation';

// import recources
import developer from '../../assets/image/developer.jpg'

//import translation
import { useTranslation } from "react-i18next";
import "../../i18n";

function Exclusive({locale}) {

    //get locale
    const { t } = useTranslation();

    return (
        <Container>
            <Row>
                <Col xxl={12}>
                    <section className="mapSection">

                        <div className="sectionHeader">
                            <div className="sectionHeaderLeft">
                                <h2>RELUX</h2>
                                <p>ექსკლუზიური შეკვეთა</p>
                            </div>
                        </div>

                        {/* exclusive box */}
                        <div className="exclusiveOrderBox">
                            <div className="exclusiveOrderBoxIcon">
                                <FontAwesomeIcon icon={faKey} />
                            </div>
                            <div className="exclusiveOrderBoxContent">
                                <h3>იპოვეთ ან შეგვიკვეთეთ სასურველი უძრავი ქონება</h3>
                            </div>
                            <div className="exclusiveOrderBoxAction">
                                <Link to={`/${locale}/property?page=1`} className="exclusiveOrderBoxBtn">
                                    ვრცლად
                                    <FontAwesomeIcon icon={faArrowRight} />
                                </Link>
                            </div>
                        </div>

                    </section>
                </Col>
            </Row>
        </Container>
    )

}

export default Exclusive;